export default {"src":"/_next/static/media/profile-circle.b334f89d.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};